// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3gJQ-","comment":"styles_comment__OnjLL"};